import React, {useState} from 'react';
import Popover from 'react-tiny-popover';
import {useHistory} from 'react-router';

import UserDetails from '../../../UserDetails';

import ActionList from '../../../ActionList';

import styles from './LoggedInUser.module.scss';
import {ActionListItemDescriptor} from '../../../ActionList/types';
import {useCurrentUserContext} from '../../../../context/CurrentUserProvider';
import {useMusicKitContext} from '../../../../context/MusicKitProvider/MusicKitProvider';

export interface Props {
  name: string;
  profilePhoto: string;
  onClick?(): void;
  fullSizeQueueSidebar: boolean;
  setFullSizeQueueSidebar: any;
}

export default function LoggedInUser({
  name,
  profilePhoto,
  onClick,
  fullSizeQueueSidebar,
  setFullSizeQueueSidebar,
}: Props) {
  const history = useHistory();
  const currentUser = useCurrentUserContext();
  const musicKit = useMusicKitContext();

  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopoverActive = () => setPopoverActive(!popoverActive);

  const handleActivatorClick = () => {
    togglePopoverActive();
    if (onClick) {
      onClick();
    }
  };

  const logout = async () => {
    if (currentUser.loggedIn) {
      const logoutSuccessful = await currentUser.logout();
      if (logoutSuccessful) history.push('/login');
    }
  };

  const userDetailsOptions: ActionListItemDescriptor[] = [
    {
      id: '0',
      content: 'View Profile (Coming soon)',
      disabled: true,
      onAction: () => {},
    },
    {
      id: '7',
      content: fullSizeQueueSidebar ? 'Hide Sidebar' : 'Show Sidebar',
      onAction: () => {
        setFullSizeQueueSidebar(!fullSizeQueueSidebar);
      },
    },
    {
      id: '3',
      content: 'Login Page 🚧',
      onAction: () => {
        history.push('/login');
      },
    },
    {
      id: '4',
      content: 'Update Account Page 🚧',
      onAction: () => {
        history.push('/update_account');
      },
    },
    {
      id: '5',
      content: 'Sign in to Music Kit 🚧',
      onAction: async () => {
        const token = await musicKit!.authorize();
        currentUser.updateToken(token);
      },
    },
    {
      id: '1',
      content: 'Settings ⚙️',
      onAction: () => {
        history.push('/settings');
      },
    },
    {
      id: '2',
      content: 'Logout 🚪',
      destructive: true,
      onAction: logout,
    },
  ];

  const activatorMarkup = (
    <Popover
      position="bottom"
      align="end"
      isOpen={popoverActive}
      content={<ActionList items={userDetailsOptions} />}
      containerClassName={styles.Popover}
      onClickOutside={togglePopoverActive}
      transitionDuration={0.15}
    >
      <UserDetails
        mainText={fullSizeQueueSidebar ? name : ''}
        profilePhoto={profilePhoto}
        onClick={handleActivatorClick}
        disclosure={fullSizeQueueSidebar}
      />
    </Popover>
  );

  return <>{activatorMarkup}</>;
}
